<template>
  <form @submit.prevent="submit">
    <fields
      :fields="fields.all()"
      :model="model"
      :errors="errors"
      layout="vertical" />
    <div class="form-group">
      <b-button
        type="submit"
        variant="primary">
        Save
      </b-button>
      <b-button
        type="button"
        variant="light"
        @click="cancel">
        Cancel
      </b-button>
    </div>
  </form>
</template>

<script>
import ResourceFormMixin from '../mixins/ResourceFormMixin';
import Proxy from './Proxy';
import Slugify from '../mixins/SlugifyMixin';

export default {
  name: 'NewsForm',

  mixins: [ResourceFormMixin, Slugify('model.title', 'model.slug')],

  created() {
    this.loadForm(Proxy);
  },

  methods: {
    submit() {
      this.save(Proxy)
        .then(() => {
          this.$toast.success('News was saved successfully');
        });
    },
  },

};
</script>
